import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://cyabeydudbhlwkpzymuh.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN5YWJleWR1ZGJobHdrcHp5bXVoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIwNDc4MDAsImV4cCI6MjA4NzYyMzgwMH0.uf5rttd2r76Mb_e5NmMgW-POImMStRl8RhT-81tngwc';

export const supabase = createClient(supabaseUrl, supabaseKey);

// --- AUTOMATION ENGINE LISTENER ---
// Call this function whenever a major event happens in the CRM.
export const fireAutomationEvent = async (triggerEvent, clientData) => {
    try {
        // 1. Check the database to see if a rule exists and is active
        const { data: rule, error: ruleError } = await supabase
            .from('crm_automation_rules')
            .select('*')
            .eq('trigger_event', triggerEvent)
            .eq('is_active', true)
            .maybeSingle(); // maybeSingle ensures it doesn't crash if 0 rules are found

        // If no active rule exists, silently exit. The system just moves on!
        if (ruleError || !rule) return;

        // 2. A rule was found! Fire the Edge Function with the saved Template ID.
        console.log(`Automation triggered for ${triggerEvent}. Sending template: ${rule.template_id}`);
        
        const { error: emailError } = await supabase.functions.invoke('send-branded-email', {
            body: {
                templateId: rule.template_id,
                agentName: 'The Nommia Team', // Or pass the logged-in agent's name if you prefer
                clientData: clientData
            }
        });

        if (emailError) {
            console.error(`Failed to send automation email for ${triggerEvent}:`, emailError);
        }

    } catch (err) {
        console.error(`Automation Engine Error (${triggerEvent}):`, err);
    }
};